type ContentProps = {
  [key: string]: string;
};

export function getCsbOptions(content: ContentProps) {
  return [
    {
      icon: 'person',
      value: content.option0,
      label: content.option0,
      checked: false
    },
    {
      icon: 'group',
      value: content.option1,
      label: content.option1,
      checked: false
    }
  ];
}
